import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import _ from 'lodash';

interface Task {
  start: string;
  end: string;
  [prop: string]: any;
}

@Component({
  selector: 'host-vertical-task-calendar',
  templateUrl: './task-calendar.component.html',
  styleUrls: ['./task-calendar.component.scss']
})
export class VerticalTaskCalendarComponent implements OnInit, OnChanges {
  @Input() selectedTask;
  @Input() listOfTask = [];
  @Output() onClickTask = new EventEmitter();
  private readonly timelineHeight = 30;
  private readonly Formatter = 'YYYY-MM-DD HH:mm';
  private rangeStart: Moment;
  private rangeEnd: Moment;
  readonly bgColor = {
    0: '#22975d',
    1: '#db5172',
    2: '#3475bc'
  };
  readonly typeMap = {
    0: '保洁',
    1: '维护',
    2: '接待',
    3: '客房服务',
    4: '其他',
  };

  get listOfTimeline () {
    const result = [];
    if (this.rangeStart && this.rangeEnd) {
      const start = this.rangeStart.clone();

      while (start.isSameOrBefore(this.rangeEnd, 'm')) {
        result.push(start.format(this.Formatter));
        start.add(1, 'h');
      }
    }

    return result;
  }

  constructor() { }

  ngOnInit() {
    // this.init();
  }

  ngOnChanges (changes: SimpleChanges) {
    console.log('changes: ', changes);
    const value = changes['listOfTask'];
    if (!value) {
      return;
    }

    if (value['currentValue'] !== value['previousValue']) {
      this.init();
    }
  }

  clickTask (id) {
    this.selectedTask = id;
    this.onClickTask.emit(id);
  }

  private init () {
    const unifiedTasks = this.unifiedTaskTimeFormat(this.listOfTask);
    const orderedTasks = this.sortTasksByTime(unifiedTasks);

    this.listOfTask = orderedTasks;

    [ this.rangeStart, this.rangeEnd ] = this.getTimelineRange(this.listOfTask);

    // console.log('list of tasks', orderedTasks, ' range start: ', this.rangeStart, ' range end: ', this.rangeEnd);

    const list = this.findTasksConflictWithEachOther(this.listOfTask);
    console.log('list: ', list);

    list.forEach((group, index) => {

      this.determineTasksPosition(group);

      const sortedGroup = this.sortTasksByPosition(group);

      this.determineTasksStyle(sortedGroup);

    });

  }

  private unifiedTaskTimeFormat (list): Task[] {
    return list.map(task => {
      const Formatter = this.Formatter;

      const time = task.expected;
      const start = moment(time).format(Formatter);
      const end = moment(time).add(1, 'h').format(Formatter);

      return { ...task, start, end };
    });
  }

  private sortTasksByTime (list: Task[]) {
    return list.sort((a, b) => moment(a.start).diff(b.start, 'm'));
  }

  private sortTasksByPosition (list: Task[]) {
    return list.sort((a, b) => a['_index_'] - b['_index_']);
  }

  private getTimelineRange (list: Task[]): Moment[] {
    if (list.length === 0) {
      return [null, null];
    }

    const start = moment(_.head(list).start);
    const end = moment(_.last(list).end);

    if (start.minute() !== 0) {
      start.minute(0);
    }

    if (end.minute() !== 0) {
      end.minute(0).add(1, 'h');
    }

    return [start, end];
  }
  private findTasksConflictWithEachOther (list: Task[]): Task[][] {
    const result = [];

    list.forEach(task => {
      const conflicts = list.filter(t => this.isConflict(
        t.start, t.end, task.start, task.end
      ) && t !== task);

      const conflictsArr = [];
      conflicts.forEach(c => {
        if (this.isConflictWithAll(
          c.start, c.end, conflictsArr
        )) {
          conflictsArr.push(c);
        }
      });

      /** 去除重复的。TODO: 有点复杂，待优化 */
      const group = [ task, ...conflictsArr ];
      if (_.every(result, g => _.xorWith(group, g, 'id').length !== 0)) {
        result.push([ task, ...conflictsArr ]);
      }
    });
    return result;
  }

  private determineTasksPosition (list: Task[]) {
    const occupiedIndex = list.map(task => task['_index_']);
    const waitAllocatedIndex = this.allocateIndex(occupiedIndex);

    list.forEach(task => {
      if (!task['_iflag_']) {
        task['_iflag_'] = true;
        task['_index_'] = waitAllocatedIndex.shift();
      }
    });
  }

  private determineTasksStyle (list: Task[]) {
    const occupiedWidth = list.reduce((total, current) => total + (current['_width_'] || 0), 0);

    const remainedWidth = 100 - occupiedWidth;
    const remainedCount = list.filter(task => !task['_wflag_']).length;

    list.forEach((task, index) => {
      if (!task['_wflag_']) {
        // const style = this.getOrderStyle(task.start, task.end);
        const style = this.getTaskStyle(task);

        const preWidth = list.slice(0, index).reduce((total, current) => total + current['_width_'], 0) || 0;

        let width = remainedWidth / remainedCount;
        const pre = list[index - 1];
        const nex = list[index + 1];
        if (nex && nex['_left_']) {
          if (!pre) {
            width = nex['_left_'];
          } else {
            width = nex['_left_'] - preWidth;
          }
        }

        task['_wflag_'] = true;
        task['_width_'] = width;
        task['_left_'] = preWidth;
        // console.log('[hour-calendar] determine order : ', order.client.name, ' prewidth: ', preWidth);
        task['style'] = { ...style, width: `${width}%`, left: `${preWidth}%` }
      }
    });
  }

  private getTaskStyle (task) {

    const { start, end } = task;

    const range = moment(this.rangeEnd).diff(this.rangeStart, 'm'); // 总时间跨度，单位分钟
    const px = range / 60 * this.timelineHeight; // 总高度，单位像素

    const pxPerMinute = px / range; // 每分钟代表的像素高度

    const height = this.timelineHeight;
    const top = moment(start).diff(this.rangeStart, 'm') * pxPerMinute;

    return {
      height, top
    };
  }

  /**
   * @TODO: 优化。算法太复杂，可读性太差
   * 我坚信有更好的处理方式。奈何智商有限，算法储备不足，心有余而力不足。恨！
   * 长恨此身非我有，何时忘却营营。小舟从此逝，江海寄余生
   */
  private allocateIndex (list) {
    const total = list.length;

    // const waitAllocated = list.filter(i => i === undefined).length;
    const allocated = list.filter(i => i !== undefined).sort((a, b) => a - b);
    const waitAllocated = total - allocated.length;

    if (waitAllocated === 0) {
      return [];
    }

    const min = Math.min.apply(null, allocated);
    const max = Math.max.apply(null, allocated);

    const result = Array(waitAllocated).fill(0);

    if (total === waitAllocated) {
      return result.map((item, index) => index);
      // result[0] = 0;
    } else {
            // 遵循向左优先的原则，尽量往左放
      const parts = this.splitNumbersByContinuity(allocated);
      if (parts.length === 1) { // 连续的 [1,2,3]
        const part = parts[0];

        const min = Math.min.apply(null, part);
        const max = Math.max.apply(null, part);

        if (min !== 0) { // [ 1,2,3 ]
          return result.map((item , index) => min / waitAllocated * index);
        } else { // [0, 1, 2, 3]
          return result.map((item, index) => max + index + 1);
        }
      } else { // 不连续 [ [0, 1], [4, 5] ] 或者 [ [1, 2], [4, 5] ]
        const firPart = parts[0];
        const secPart = parts[1];

        const min = Math.max.apply(null, firPart);
        const max = Math.min.apply(null, secPart);

        if (firPart[0] !== 0) { // [ [1, 2], [4, 5] ]
          return result.map((item , index) => firPart[0] / waitAllocated * index);
        } else { // [ [0, 1], [4, 5] ]
          if (max - min > waitAllocated) {
            return result.map((i, index) => min + 1 + index);
          } else {
            return result.map((i, index) => min + (max - min) / (waitAllocated + 1) * (index + 1));
          }
        }

      }
    }
  }

  private splitNumbersByContinuity (array: number[]) {
    const result = [];
    let temp = [];

    array
      .sort((a, b) => a - b)
      .concat(Infinity)
      .reduce((acc, cur) => {
        temp.push(acc);

        if (cur - acc > 1) {
          result.push(temp);
          temp = [];
        }

        return cur;
      });

    if (_.isEmpty(result)) {
      return [ array ];
    }

    return result;
  }

  private isConflict (
    leftStartTime,
    leftEndTime,
    rightStartTime,
    rightEndTime,
  ) {
    return moment(rightStartTime).isBetween(leftStartTime, leftEndTime, 'm', '[)')
        || moment(leftStartTime).isBetween(rightStartTime, rightEndTime, 'm', '[)')
        || moment(leftEndTime).isBetween(rightStartTime, rightEndTime, 'm')
        || moment(rightEndTime).isBetween(leftStartTime, leftEndTime, 'm');
  }

  private isConflictWithAll (
    leftStartTime,
    leftEndTime,
    list: Task[]
  ) {
    return list.every(item => this.isConflict(leftStartTime, leftEndTime, item.start, item.end));
  }

}
